/* eslint-disable react/no-unknown-property */
import React from 'react';
import { AvatarSkeleton, TextSkeleton, TypographyName } from '@doveit/bricks';
import * as styles from './AgentLeaderboardPositionPreview.style';
import AgentLeaderboardItemSkeleton from '../agent-leaderboard-item/AgentLeaderboardItem.skeleton';

export const AgentLeaderboardPositionPreviewSkeleton: React.FC = () => (
  <div css={styles.basic}>
    <div css={styles.hiddenPosition}>
      <AvatarSkeleton size="XS" />
      <TextSkeleton
        typography={TypographyName.CAPTION}
        width="5.5rem"
      />
    </div>
    <div css={styles.hiddenPosition}>
      <AvatarSkeleton size="XS" />
      <TextSkeleton
        typography={TypographyName.CAPTION}
        width="5.5rem"
      />
    </div>
    <AgentLeaderboardItemSkeleton
      size="M"
    />
    <div css={styles.hiddenPosition}>
      <AvatarSkeleton size="XS" />
      <TextSkeleton
        typography={TypographyName.CAPTION}
        width="5.5rem"
      />
    </div>
    <div css={styles.hiddenPosition}>
      <AvatarSkeleton size="XS" />
      <TextSkeleton
        typography={TypographyName.CAPTION}
        width="5.5rem"
      />
    </div>
  </div>
);

export default AgentLeaderboardPositionPreviewSkeleton;
